import styled, { keyframes } from 'styled-components';

import { Color } from '../../../constants/Colors';
import { Indexes, MediaQuery, Transition } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: ${Transition.OPACITY_EASE};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0 auto 150px auto;
  max-width: 1200px;

  ${MediaQuery.M_TO_XL} {
    margin: 0 45px 150px 45px;
  }

  ${MediaQuery.L_AND_DOWN} {
    flex-direction: column;
    margin-bottom: 100px;
    align-items: normal;
  }
`;

export const fadeIn = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`;

export const IllustrationWrapper = styled.div`
  box-sizing: border-box;
  background: ${Color.WHISPER};
  height: 350px;
  border-radius: 30px;

  ${MediaQuery.L_AND_DOWN} {
    overflow: hidden;
    max-height: ${({ isVisible }) => (isVisible ? '500px' : '0px')};
    align-self: center;
    height: inherit;
    width: 85%;
    margin-bottom: ${({ isVisible }) => (isVisible ? '20px' : '0px')};
  }

  div {
    height: 350px;
    overflow: hidden;
    border-radius: 30px;
    max-height: ${({ isVisible }) => (isVisible ? '700px' : '0px')};
    max-width: ${({ isVisible }) => (isVisible ? '1000px' : '0px')};
    opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
    transition: ${Transition.OPACITY_EASE};

    ${MediaQuery.L_AND_DOWN} {
      align-self: center;
      width: 100%;
      height: inherit;
    }
  }
`;

export const ListWrapper = styled.div`
  margin-left: 30px;
  display: flex;
  flex-direction: column;

  ${MediaQuery.M_TO_XL} {
    width: 80%;
  }

  ${MediaQuery.L_AND_DOWN} {
    margin: 0px;
    align-self: center;
    width: 85%;
  }
`;

export const Card = styled.div`
  max-height: ${({ isVisible }) => (isVisible ? 'inherit' : '0px')};
  animation-name: ${({ isVisible }) => (isVisible ? fadeIn : 'none')};
  animation-duration: 1s;
  animation-fill-mode: normal;
  background: ${({ color }) => color};
  border-radius: 15px;
  margin-bottom: ${({ isVisible }) => (isVisible ? '30px' : '0px')};
  overflow: hidden;
  max-width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 40px 30px;
  flex-direction: column;
  width: 90%;

  p:nth-child(2) {
    margin-top: 30px;
  }

  ${MediaQuery.L_AND_DOWN} {
    padding: 30px 30px;
  }

  ${MediaQuery.S_AND_DOWN} {
    width: 80%;
  }
`;

const load = keyframes`
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
`;

export const ProgessBar = styled.div`
  background: ${({ color }) => color};
  width: ${({ isClicked }) => (isClicked ? '100%' : '0%')};
  height: 3px;
  animation-name: ${({ inView, isVisible, isClicked }) =>
    inView && isVisible && !isClicked ? load : 'none'};
  animation-duration: 20s;
  animation-direction: normal;
  animation-fill-mode: forwards;
`;

export const CtaTitle = styled.span`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  ${Typography.XL_BOLDER};
  cursor: pointer;
  margin: 0 0 30px 40px;
`;

export const ContentTitle = styled.span`
  ${Typography.XL_BOLDER};
  margin-bottom: 15px;
`;

export const ButtonContainer = styled.div`
  text-align: center;
  & > * {
    min-width: 150px;
    justify-content: center;

    ${MediaQuery.L_AND_DOWN} {
      max-width: 150px;
      margin: auto;
    }
  }
`;

export const WrapperIframe = styled.div`
  width: 600px;
  height: 400px;

  ${MediaQuery.L_AND_DOWN} {
    width: 400px;
    height: 300px;
  }

  ${MediaQuery.S_AND_DOWN} {
    width: 300px;
    height: 200px;
  }
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;

export const ModalOverlay = styled.div`
  z-index: ${Indexes.MODAL};
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(33, 37, 41, 0.45);
`;

export const ModalWrapper = styled.div`
  max-width: 650px;
  border-radius: 15px;
  text-align: center;

  ${MediaQuery.M_AND_DOWN} {
    background-color: ${Color.WHITE};
    border-radius: initial;
    max-width: initial;
    height: auto;
    width: 100%;
  }
`;

export const StyledCross = styled.button`
  float: right;
  margin: 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  height: 35px;
  width: 35px;
  background-color: ${Color.WHISPER};
  border: 2px solid transparent;
  transition: ${Transition.ALL_EASE};

  svg {
    font-size: 20px;
    padding-top: 5px;
  }

  &:hover {
    border: 2px solid ${Color.WHISPER};
    background-color: transparent;
  }

  ${MediaQuery.M_AND_DOWN} {
    background-color: transparent;
    border: none;
  }
`;

export const ModalContent = styled.div`
  background-color: transparent;
  margin: 30px;

  ${MediaQuery.M_AND_DOWN} {
    margin-top: 50px;
  }
`;
